import React, { useState } from "react";
import { Modal, Button, Input, Select, Form } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ApartmentIcon from "../../assets/images/apartment-icon.svg";
import VillaIcon from "../../assets/images/house-villa-icon.svg";
import OfficeIcon from "../../assets/images/office-icon.svg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useStore } from "../../context/StoreContext";
import { useAuth } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
import { getCoordinates } from "../../helper/functions";
import LocationPicker from "../../components/LocationPicker";
const { Option } = Select;

const addressTypes = [
  { type: "Apartment", icon: ApartmentIcon },
  { type: "House/Villa", icon: VillaIcon },
  { type: "Office", icon: OfficeIcon },
];
const DeliveryAddressModal = ({ open, onClose }) => {
  const [addressType, setAddressType] = useState("Apartment");
  const [form] = Form.useForm();
  const [phoneNumber, setPhoneNumber] = useState("");
  const { addAddress } = useStore();
  //------ on submit function -------
  const onFinish = async (values) => {
    const coordinates = await getCoordinates();

    // remove phone from values using destructuring
    const { phone, ...restValues } = values;

    let addressData = {
      ...restValues,
      type: addressType,
      latitude: String(coordinates.latitude),
      longitude: String(coordinates.longitude),
    };

    // If phone number is provided, format it properly
    if (phone) {
      let countryCode, number;

      if (phone.length === 12) {
        countryCode = phone.substring(0, 2);
        number = phone.substring(2);
      } else if (phone.length === 13) {
        countryCode = phone.substring(0, 3);
        number = phone.substring(3);
      } else if (phone.length === 11) {
        countryCode = phone.substring(0, 1);
        number = phone.substring(1);
      }

      addressData = {
        ...addressData,
        mobileNumber: number,
        countryCode: `+${countryCode}`,
      };
    }

    const response = await addAddress(addressData);
    if (response.status === 200) {
      ShowToast(response.message, Severty.SUCCESS);
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      width={956}
      className="delivery-modal"
    >
      <div className="delivery-modal-container">
        {/* Left Side */}
        <div className="delivery-form">
          <div className="delivery-header">
            <h2>Delivery address</h2>
            <Button
              icon={<CloseOutlined />}
              onClick={onClose}
              className="close-btn"
            />
          </div>

          <div className="address-type-selector">
            {addressTypes.map(({ type, icon }) => (
              <div
                key={type}
                className={`address-type ${
                  addressType === type ? "selected" : ""
                }`}
                onClick={() => setAddressType(type)}
              >
                <img src={icon} alt={type} className="address-type-icon" />
                <span className="address-type-label">{type}</span>
              </div>
            ))}
          </div>

          <Form
            form={form}
            name="address_details"
            layout="vertical"
            onFinish={onFinish}
          >
            {/* Street Address */}
            <Form.Item
              name="streetAddress"
              rules={[
                {
                  required: true,
                  message: "Please enter your street address!",
                },
              ]}
            >
              <Input placeholder="Street Address*" className="input-full" />
            </Form.Item>

            {/* Apartment/Office/Villa Number */}
            <Form.Item
              name="houseNumber"
              rules={[
                {
                  required: true,
                  message: "Please enter your apartment/office/villa number!",
                },
              ]}
            >
              <Input
                placeholder="Enter your apartment/office/villa number*"
                className="input-full"
              />
            </Form.Item>

            {/* State */}
            <Form.Item
              name="state"
              rules={[{ required: true, message: "Please enter your state!" }]}
            >
              <Input placeholder="State*" className="input-full" />
            </Form.Item>

            {/* Country */}
            <Form.Item
              name="country"
              rules={[
                { required: true, message: "Please enter your country!" },
              ]}
            >
              <Input placeholder="Country*" className="input-full" />
            </Form.Item>

            {/* Avenue (Optional) */}
            <Form.Item name="avenue">
              <Input placeholder="Avenue (Optional)" className="input-full" />
            </Form.Item>

            <div className="address-personal-information">
              Personal Information
            </div>

            {/* Phone Number Input */}
            <Form.Item
              name="phone"
              className="main-new-height-mobile-input"
              rules={[
                { required: true, message: "Please enter your phone number!" },
              ]}
            >
              <PhoneInput
                country="kw"
                defaultCountry="kw"
                value={phoneNumber}
                onChange={setPhoneNumber}
                inputStyle={{
                  width: "100%",
                  height: "57px",
                  borderRadius: "0px",
                  background: "transparent",
                  // color: "white",
                  border: "none",
                  fontSize: "16px",
                }}
                buttonStyle={{
                  background: "#54545469",
                  border: "none",
                  borderRadius: "8px 0 0 8px",
                  height: "57px",
                  color: "white",
                }}
                containerStyle={{
                  height: "57px",
                  borderRadius: "12px",
                  background: "#54545469",
                  border: "none",
                }}
                dropdownStyle={{
                  background: "#2a2a2a",
                  border: "1px solid #54545469",
                  borderRadius: "12px",
                  color: "white",
                }}
                placeholder="Phone Number"
              />
            </Form.Item>

            {/* Name  */}
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter your name!",
                },
              ]}
            >
              <Input placeholder="Enter your name*" className="input-full" />
            </Form.Item>

            <Button className="Fill-button" type="default" htmlType="submit">
              Add Address
            </Button>
          </Form>
        </div>

        {/* Right Side - Map */}
        <div className="map-area">
          <LocationPicker
            onLocationSelect={(location) => {
              form.setFieldsValue({
                streetAddress: location.address,
                state: location.state,
                country: location.country,
              });
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryAddressModal;
